var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasteCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 414,
    viewBox: "0 0 468 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paste-code",
    transform: "translate(-150 -1798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1131",
    "data-name": "Rectangle 1131",
    width: 468,
    height: 414,
    transform: "translate(150 1798)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(149.995 1798.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 95.017,
    height: 179.613,
    transform: "translate(81.74 187.94)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 95.017,
    height: 179.613,
    transform: "translate(53.544 187.94)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M154.352,266.738H72.79V238.27h81.562Zm-80.565-1h79.559V239.276H73.788Z",
    transform: "translate(-12.783 -41.83)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M104.15,238.88H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V238.88Z",
    transform: "translate(-18.288 -41.937)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M154.352,310.608H72.79V282.14h81.562Zm-80.565-1h79.559V283.138H73.788Z",
    transform: "translate(-12.783 -49.531)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M104.15,282.75H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V282.75Z",
    transform: "translate(-18.288 -49.638)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M154.352,354.476H72.79V326h81.562Zm-80.565-1h79.559V327.006H73.788Z",
    transform: "translate(-12.783 -57.231)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M104.15,326.61H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V326.61Z",
    transform: "translate(-18.288 -57.338)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M154.352,398.346H72.79V369.87h81.562Zm-80.565-1.006h79.559V370.876H73.788Z",
    transform: "translate(-12.783 -64.933)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M104.15,370.48H135.1v2.168a3.5,3.5,0,0,1-3.5,3.5H107.687a3.5,3.5,0,0,1-3.5-3.5V370.48Z",
    transform: "translate(-18.288 -65.04)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 103.212,
    height: 8.945,
    transform: "translate(49.331 181.221)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 31.032,
    height: 8.945,
    transform: "translate(152.535 181.221)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 4.996,
    height: 9.176,
    transform: "translate(53.544 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 4.996,
    height: 9.176,
    transform: "translate(84.394 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 4.996,
    height: 9.176,
    transform: "translate(140.753 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 4.996,
    height: 9.176,
    transform: "translate(168.924 367.554)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M133.974,190.56l9.621,24.61-5.977-.033-4.8-15.12Z",
    transform: "translate(-23.321 -33.454)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M93.686,162.99,90.38,210.132l34.132.717,3.842-47.859Z",
    transform: "translate(-15.871 -28.614)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M97.944,167.541,95.19,206.784l25.376,1.187,3.545-40.662Z",
    transform: "translate(-16.715 -29.372)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M104.841,174.32l-2.061,27.586h14l2.473-27.586Z",
    transform: "translate(-18.048 -30.603)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 110.162,
    height: 108.241,
    transform: "translate(157.151)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 102.445,
    height: 102.445,
    transform: "translate(160.985 2.96)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 33.423,
    height: 33.423,
    transform: "translate(195.496 37.471)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M355.311,12.08c-1.245,17.767,0,50.843-6.464,67.431s-15.1,33.67-31.329,41.09c-19.927,9.135-43.349,5.268-64.612,10.619-33.332,8.385-57.423,38.963-67.712,71.727s-9.1,67.942-7.865,102.289l170.091,23.6s.89-69.113,15.73-87.976,85.3-35.839,108.579-87.5C492.68,106.875,499,33.145,499,33.145Z",
    transform: "translate(-30.995 -2.121)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M477.157,101.111c0,.239-15.524-1.649-34.627-4.279s-34.519-4.889-34.47-5.136,15.524,1.649,34.627,4.287S477.19,100.88,477.157,101.111Z",
    transform: "translate(-71.641 -16.094)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M474.9,117.911c0,.231-15.533-1.649-34.627-4.287s-34.519-4.9-34.487-5.128,15.516,1.649,34.627,4.279S474.928,117.68,474.9,117.911Z",
    transform: "translate(-71.243 -19.044)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M467.211,135.039c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S467.269,134.8,467.211,135.039Z",
    transform: "translate(-69.891 -22.049)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M453.221,152.319c0,.231-15.524-1.69-34.627-4.287s-34.528-4.9-34.495-5.136,15.524,1.649,34.627,4.287S453.271,152.047,453.221,152.319Z",
    transform: "translate(-67.435 -25.083)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M430.951,169.561c0,.231-15.524-1.649-34.627-4.287s-34.528-4.9-34.495-5.128,15.524,1.649,34.627,4.279S430.984,169.322,430.951,169.561Z",
    transform: "translate(-63.525 -28.111)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M525.856,108.122c-.041.239-3.85-.19-8.508-.948s-8.4-1.566-8.368-1.8,3.85.19,8.508.948S525.9,107.891,525.856,108.122Z",
    transform: "translate(-89.358 -18.488)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M481.283,83.991c0,.231-15.533-1.649-34.627-4.287s-34.52-4.9-34.487-5.128,15.516,1.649,34.627,4.279S481.283,83.752,481.283,83.991Z",
    transform: "translate(-72.363 -13.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M529.976,91c0,.231-3.842-.19-8.5-.948s-8.409-1.566-8.376-1.8,3.85.19,8.508.948S530.018,90.771,529.976,91Z",
    transform: "translate(-90.082 -15.483)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M485.931,66.861c0,.239-15.524-1.649-34.627-4.279s-34.519-4.9-34.495-5.136,15.524,1.649,34.627,4.287S485.964,66.63,485.931,66.861Z",
    transform: "translate(-73.178 -10.081)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M534.636,73.872c0,.239-3.842-.19-8.508-.948s-8.4-1.566-8.368-1.8,3.85.19,8.508.956S534.678,73.641,534.636,73.872Z",
    transform: "translate(-90.9 -12.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M488.121,49.741c0,.231-15.524-1.649-34.627-4.287S419,40.557,419,40.326s15.524,1.649,34.627,4.279S488.154,49.5,488.121,49.741Z",
    transform: "translate(-73.562 -7.076)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M536.835,56.747c0,.231-3.85-.19-8.508-.948s-8.409-1.566-8.327-1.814,3.842.19,8.508.948S536.868,56.516,536.835,56.747Z",
    transform: "translate(-91.293 -9.465)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M525.126,123.1c-.041.231-3.85-.2-8.508-.956s-8.409-1.558-8.368-1.8,3.842.2,8.508.956S525.159,122.861,525.126,123.1Z",
    transform: "translate(-89.23 -21.116)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M520.046,143.816c0,.231-3.85-.214-8.517-.989s-8.451-1.583-8.36-1.756c0-.3,3.842.148,8.5.915S520.087,143.585,520.046,143.816Z",
    transform: "translate(-88.338 -24.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M512.706,161.406c0,.239-3.85-.214-8.517-.981s-8.451-1.591-8.36-1.764,3.85.148,8.5.915S512.747,161.134,512.706,161.406Z",
    transform: "translate(-87.05 -27.846)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M496.926,178.026c0,.231-3.858-.214-8.517-.989s-8.451-1.583-8.36-1.756,3.842.148,8.492.915S496.959,177.795,496.926,178.026Z",
    transform: "translate(-84.279 -30.763)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M404.523,189.511c0,.239-23.291-2.861-51.94-6.917s-51.866-7.535-51.833-7.766,23.291,2.861,51.94,6.917S404.556,189.28,404.523,189.511Z",
    transform: "translate(-52.803 -30.69)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M388.239,206.486a5.26,5.26,0,0,1-1.154-.091l-3.3-.429-12-1.748-39.573-6.1c-15.442-2.473-29.416-4.691-39.524-6.381l-11.954-2.069c-1.41-.256-2.473-.462-3.248-.618a6.322,6.322,0,0,1-1.113-.289,6.91,6.91,0,0,1,1.154.115l3.257.462,12,1.8,39.573,6.142,39.524,6.34,11.971,2.02,3.24.594A6.694,6.694,0,0,1,388.239,206.486Z",
    transform: "translate(-48.523 -33.138)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M362.374,222.786c.148.148-1.525,0-4.279-.371s-6.818-.915-11.79-1.649c-9.951-1.443-23.686-3.529-38.84-5.895s-28.856-4.576-38.749-6.225l-11.74-1.987-3.182-.585a6.439,6.439,0,0,1-1.1-.256,5.036,5.036,0,0,1,1.129.091l3.207.42,11.781,1.723,38.823,5.969,38.8,6.15Z",
    transform: "translate(-44.365 -36.132)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M470.558,201.725c0,.231-3.85-.214-8.517-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S470.6,201.495,470.558,201.725Z",
    transform: "translate(-79.652 -34.916)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M450.236,213.043c-.041.231-3.858-.214-8.525-.989s-8.442-1.583-8.352-1.764,3.842.148,8.492.915S450.269,212.8,450.236,213.043Z",
    transform: "translate(-76.083 -36.909)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M422.868,232.1c0,.231-3.85-.214-8.517-.989s-8.442-1.583-8.352-1.756c0-.3,3.842.14,8.492.915S422.909,231.865,422.868,232.1Z",
    transform: "translate(-71.279 -40.247)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M346.834,258.575c0,.231-28.79-4-64.208-9.448s-64.109-10.058-64.076-10.289,28.781,4,64.208,9.448S346.867,258.344,346.834,258.575Z",
    transform: "translate(-38.372 -41.928)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M344.326,299.069c0,.239-9.456-1.1-21.04-2.968s-20.949-3.578-20.916-3.817,9.465,1.1,21.048,2.976S344.367,298.838,344.326,299.069Z",
    transform: "translate(-53.087 -51.307)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M473.776,189.62c-4.765.1-7.643,5.54-7.89,10.3s1.055,9.63-.115,14.246c-1.484,5.87-6.686,10.281-8.038,16.176-1.591,6.958,2.515,13.9,3.042,21.015.264,3.463-.33,7.008.47,10.38a12.779,12.779,0,0,0,25.047-.973c.824-5.392-1.773-10.949-.618-16.283.824-3.949,3.71-7.42,3.759-11.435.066-4.807-3.842-8.764-4.765-13.48s1.253-9.465,1.377-14.263c.223-8.615-3.661-15.186-12.268-15.664",
    transform: "translate(-80.298 -33.289)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M479.06,216.9a5.836,5.836,0,0,1,0,.758c0,.544-.082,1.27-.14,2.193-.148,1.937-.346,4.666-.594,8.03-.511,6.785-1.2,16.159-1.9,26.514s-1.278,19.737-1.69,26.531c-.206,3.364-.371,6.1-.495,8.038-.066.915-.115,1.649-.148,2.185a6.787,6.787,0,0,1-.082.759,3.822,3.822,0,0,1,0-.758c0-.544,0-1.27.066-2.193.082-1.946.206-4.683.355-8.047.33-6.8.824-16.184,1.558-26.547s1.443-19.729,2.028-26.506c.313-3.355.561-6.084.742-8.022.091-.915.165-1.649.223-2.185a4.054,4.054,0,0,1,.082-.75Z",
    transform: "translate(-83.215 -38.078)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M472.833,322.906h0a15.211,15.211,0,0,0,15.2-15.2V292.5H457.63v15.2A15.2,15.2,0,0,0,472.833,322.906Z",
    transform: "translate(-80.344 -51.35)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M457.63,301.51a2,2,0,0,1,.495.33l1.336,1.039,4.7,3.809h-.247l8.764-5.375h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.342,2.342,0,0,1,.544-.33,2.531,2.531,0,0,1-.462.437l-1.393,1.129-5.037,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.813,5.3-.132.082-.115-.1-4.584-3.957-1.261-1.121A2.659,2.659,0,0,1,457.63,301.51Z",
    transform: "translate(-80.343 -52.883)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M457.63,297.822a1.928,1.928,0,0,1,.495.338l1.336,1.031,4.7,3.809h-.247l8.764-5.367h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.343,2.343,0,0,1,.544-.33,4.361,4.361,0,0,1-.462.437l-1.393,1.138-5.037,3.949-.124.1-.132-.091-8.195-5.309h.272l-8.813,5.293-.132.082-.115-.1L459.3,299.4l-1.261-1.129C457.762,298,457.613,297.839,457.63,297.822Z",
    transform: "translate(-80.343 -52.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M457.63,305.26a2,2,0,0,1,.495.33l1.336,1.039,4.7,3.809h-.247l8.764-5.375h0l.148-.082.132.091,8.154,5.375h-.247l5.153-3.8,1.459-1.039a2.341,2.341,0,0,1,.544-.33,2.531,2.531,0,0,1-.462.437l-1.393,1.13-5.037,3.957-.124.091-.132-.082-8.195-5.309h.256l-8.8,5.268-.132.082-.115-.1-4.584-3.957-1.261-1.121C457.762,305.425,457.613,305.277,457.63,305.26Z",
    transform: "translate(-80.343 -53.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M499.676,422.51l9.7,27.833h-4.848L487.54,422.51Z",
    transform: "translate(-85.595 -74.174)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M432.662,422.51l-9.712,27.833h4.856L444.79,422.51Z",
    transform: "translate(-74.255 -74.174)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 77.547,
    height: 77.547,
    transform: "translate(412.861 349.037) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 77.547,
    height: 77.547,
    transform: "translate(437.166 349.037) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M509.718,403.229H442.41v-67.3h67.308Zm-66.3-1h65.3v-65.3h-65.3Z",
    transform: "translate(-77.672 -58.974)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M508.9,361.181c-21.889-.635-44.017-.47-65.956,0a.264.264,0,1,0,0,.528c21.9.445,44.025.61,65.956,0a.239.239,0,0,0,0-.47Z",
    transform: "translate(-77.719 -63.334)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M480.94,349.318a1.88,1.88,0,1,0,.551-1.337A1.888,1.888,0,0,0,480.94,349.318Z",
    transform: "translate(-84.436 -60.993)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M513.92,386.058a1.88,1.88,0,1,0,.551-1.337A1.888,1.888,0,0,0,513.92,386.058Z",
    transform: "translate(-90.226 -67.443)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M278.758,438.148,133.111,272.2a12.367,12.367,0,0,1,1.146-17.5L235.664,165.71a12.367,12.367,0,0,1,17.5,1.138L398.772,332.768a12.367,12.367,0,0,1-1.138,17.5L296.228,439.253A12.408,12.408,0,0,1,278.758,438.148Z",
    transform: "translate(-22.83 -28.548)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M397.148,370.759a16.951,16.951,0,1,1,1.558-23.909A16.95,16.95,0,0,1,397.148,370.759Z",
    transform: "translate(-64.786 -59.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M405.316,394a18.376,18.376,0,0,1-4.32.239,17.692,17.692,0,1,1,4.32-.239Zm-6.027-33.374a16.134,16.134,0,1,0,13.5,28.031h0a16.134,16.134,0,0,0-9.588-28.221,16.745,16.745,0,0,0-3.916.19Z",
    transform: "translate(-67.504 -63.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M191.441,257.411l-10.248,8.995-.923-1.055,9.308-8.162-2.111-2.424.94-.824Z",
    transform: "translate(-31.652 -44.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M192.206,277.776l-.932.824L185,271.411l.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.473-.19-4.081a4.617,4.617,0,0,0-3.595-1.8V263.34a6.142,6.142,0,0,1,4.65,2.35c1.822,2.078,1.921,4.32.206,5.821-.973.824-2.127,1.327-4.675,1.13l-6.488-.478Z",
    transform: "translate(-32.482 -46.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M205.691,289.916l-1.8-2.053-2.688,2.366-.932-1.055,2.7-2.358-5.07-5.771.758-.668,11.542-.528,1.022,1.171-11.212.569,3.908,4.444,2.366-2.078.907,1.022-2.374,2.078,1.8,2.053Z",
    transform: "translate(-34.747 -49.129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M222.409,308.965l-1.8-2.053-2.7,2.366-.923-1.055,2.7-2.366-5.079-5.771.767-.668,11.542-.528,1.031,1.171-11.212.569,3.908,4.444L223.011,303l.9,1.022-2.383,2.069,1.8,2.053Z",
    transform: "translate(-37.68 -52.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M232.239,318.97c-1.74,1.525-4.172,1.509-6.365-1a7.016,7.016,0,0,1-1.9-4.823l1.278-.223a5.9,5.9,0,0,0,1.583,4.188c1.525,1.74,3.182,1.921,4.427.824s1.418-2.7-.866-5.3l-1.921-2.177,5.6-3.982,4.947,5.606-.932.824-4.122-4.683-3.57,2.515,1.154,1.319C234.243,315.153,234.053,317.379,232.239,318.97Z",
    transform: "translate(-39.323 -53.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M243.2,331.4c-1.913,1.649-4.468,1.253-6.216-.742-2.383-2.721-1.8-5.854,1.435-8.7,3.487-3.05,6.975-2.745,9.407.041a6.191,6.191,0,0,1,1.583,2.91l-1.22.33a4.8,4.8,0,0,0-1.27-2.416c-1.937-2.21-4.6-2.383-7.42.058a9.727,9.727,0,0,0-.824.775,4.337,4.337,0,0,1,4.5,1.591C245.027,327.276,245.076,329.749,243.2,331.4Zm-.94-1.014c1.344-1.179,1.336-2.935-.049-4.518s-3.3-1.789-4.551-.668c-1.129.989-1.377,2.861.181,4.633,1.294,1.476,3.026,1.748,4.419.552Z",
    transform: "translate(-41.352 -56.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M257.871,348.149c-1.715,1.5-4.122,1.41-6.29-1.064a7.041,7.041,0,0,1-1.921-4.84l1.278-.223a6,6,0,0,0,1.608,4.221c1.484,1.7,3.1,1.937,4.37.824s1.278-2.646-.387-4.543l-.643-.734.775-.684,6.051-.28-4.6-5.243.932-.824,5.771,6.6-.742.66-6.192.3C259.7,344.6,259.512,346.706,257.871,348.149Z",
    transform: "translate(-43.833 -58.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M269.065,360.86c-1.921,1.649-4.477,1.261-6.216-.734-2.391-2.721-1.806-5.854,1.435-8.7,3.479-3.05,6.967-2.745,9.407.041a6.241,6.241,0,0,1,1.575,2.91l-1.22.33a4.839,4.839,0,0,0-1.261-2.416c-1.946-2.218-4.609-2.383-7.42.049-.239.214-.519.478-.824.783a4.361,4.361,0,0,1,4.51,1.583C270.887,356.746,270.961,359.219,269.065,360.86Zm-.948-1.014c1.352-1.179,1.344-2.927-.049-4.51s-3.3-1.789-4.551-.668c-1.121.989-1.369,2.861.181,4.633,1.3,1.476,3.059,1.74,4.419.544Z",
    transform: "translate(-45.892 -61.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M286.253,365.519l-.75.651-13.265,4.048-1-1.138,13.01-3.957-4.625-5.268L277.7,361.5l-.89-1.031L279.666,358Z",
    transform: "translate(-47.622 -62.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M301.8,383.284l-.742.651L287.8,387.983l-1-1.138,13-3.957-4.592-5.285-1.913,1.649-.915-1.039,2.853-2.473Z",
    transform: "translate(-50.354 -65.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M305.066,402.32c-1.814,1.591-4.287,1.047-6.431-1.4s-2.341-4.947-.528-6.53a3.4,3.4,0,0,1,4.246-.239,3.083,3.083,0,0,1,.824-3.586c1.649-1.459,3.957-.956,5.862,1.212s2.127,4.526.462,5.985a3.092,3.092,0,0,1-3.693.346A3.43,3.43,0,0,1,305.066,402.32Zm-.932-1.1c1.253-1.1,1.1-2.886-.495-4.7s-3.3-2.185-4.584-1.08-1.121,2.877.47,4.691,3.331,2.185,4.609,1.08Zm.338-5.433c1.4,1.6,2.951,1.921,4.065.94s.973-2.638-.379-4.172-2.919-1.921-4.065-.915-1.022,2.547.379,4.139Z",
    transform: "translate(-52.122 -68.42)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M317.93,412.33c-3.487,3.059-6.975,2.745-9.415,0a6.307,6.307,0,0,1-1.575-2.919l1.22-.322a4.832,4.832,0,0,0,1.27,2.416c1.937,2.21,4.6,2.383,7.42-.058.239-.206.519-.478.824-.775a4.37,4.37,0,0,1-4.51-1.591c-1.781-2.036-1.83-4.51.049-6.15s4.469-1.253,6.216.734C321.755,406.353,321.162,409.494,317.93,412.33Zm.759-3.232c1.129-.989,1.377-2.869-.181-4.642-1.294-1.476-3.059-1.74-4.419-.544s-1.344,2.935.049,4.518,3.273,1.8,4.551.668Z",
    transform: "translate(-53.889 -70.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M335.051,421.059,324.8,430.046l-.923-1.055,9.308-8.17-2.127-2.416.94-.824Z",
    transform: "translate(-56.863 -73.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M335.819,441.418l-.932.824-6.307-7.181.742-.66,7.906.6c2.16.148,3.042-.231,3.743-.824,1.187-1.039,1.187-2.515-.19-4.081a4.634,4.634,0,0,0-3.595-1.8V426.99a6.117,6.117,0,0,1,4.65,2.35c1.83,2.078,1.929,4.32.214,5.821-.981.824-2.127,1.327-4.683,1.129l-6.48-.478Z",
    transform: "translate(-57.688 -74.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M347.831,450.647c-1.715,1.5-4.122,1.41-6.29-1.064a7.041,7.041,0,0,1-1.921-4.839l1.278-.223a6,6,0,0,0,1.608,4.221c1.484,1.7,3.1,1.937,4.37.824s1.3-2.63-.346-4.559l-.643-.734.775-.676,6.043-.28-4.592-5.243.932-.824,5.771,6.6-.742.66-6.192.3C349.662,447.094,349.464,449.2,347.831,450.647Z",
    transform: "translate(-59.626 -76.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 5.92,
    height: 109.206,
    transform: "matrix(0.751, -0.66, 0.66, 0.751, 204.073, 308.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 5.92,
    height: 56.013,
    transform: "translate(230.262 356.052) rotate(-41.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_984",
    "data-name": "Rectangle 984",
    width: 45.823,
    height: 34.231,
    rx: 4.96,
    transform: "translate(188.765 176.15) rotate(48.73)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M206.4,231.457l1.649-1.443,15.566,17.734a4.947,4.947,0,1,0,7.42-6.521l-15.566-17.734,1.649-1.443,15.557,17.734a7.131,7.131,0,1,1-10.719,9.408Z",
    transform: "translate(-36.239 -38.982)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_985",
    "data-name": "Rectangle 985",
    width: 2.193,
    height: 16.192,
    transform: "translate(194.251 210.761) rotate(-41.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 117.846,
    height: 10.116,
    transform: "translate(213.511 161.64) rotate(48.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M321.81,373.77H286.326v31.576L276.02,423.69h56.087l-10.3-18.344Z",
    transform: "translate(-48.461 -65.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 286.445,
    height: 186.3,
    rx: 14.77,
    transform: "translate(110.554 123.057)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 85.858,
    height: 9.019,
    transform: "translate(212.678 358.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M215.372,162.093V327.229h-57.81a13.191,13.191,0,0,1-13.142-13.15V175.2a13.142,13.142,0,0,1,13.142-13.142Z",
    transform: "translate(-25.358 -28.451)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_989",
    "data-name": "Rectangle 989",
    width: 9.77,
    height: 9.77,
    transform: "translate(124.066 146.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    width: 9.77,
    height: 9.77,
    transform: "translate(124.066 161.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 9.77,
    height: 9.77,
    transform: "translate(124.066 175.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 9.77,
    height: 9.77,
    transform: "translate(137.381 190.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 9.77,
    height: 9.77,
    transform: "translate(137.381 204.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 9.77,
    height: 9.77,
    transform: "translate(137.381 219.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_995",
    "data-name": "Rectangle 995",
    width: 39.961,
    height: 2.663,
    transform: "translate(142.27 150.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_996",
    "data-name": "Rectangle 996",
    width: 39.961,
    height: 2.663,
    transform: "translate(142.27 164.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_997",
    "data-name": "Rectangle 997",
    width: 39.961,
    height: 2.663,
    transform: "translate(142.27 179.44)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_998",
    "data-name": "Rectangle 998",
    width: 27.528,
    height: 2.663,
    transform: "translate(154.711 193.951)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_999",
    "data-name": "Rectangle 999",
    width: 27.528,
    height: 2.663,
    transform: "translate(154.711 208.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 27.528,
    height: 2.663,
    transform: "translate(154.711 222.814)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M428.93,175.209V314.086a13.142,13.142,0,0,1-13.142,13.15H230.47V162.1H415.789a13.133,13.133,0,0,1,13.142,13.109Z",
    transform: "translate(-40.464 -28.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1001",
    "data-name": "Rectangle 1001",
    width: 86.913,
    height: 5.12,
    transform: "translate(203.724 148.078)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 67.514,
    height: 5.12,
    transform: "translate(295.633 148.078)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1003",
    "data-name": "Rectangle 1003",
    width: 49.252,
    height: 5.12,
    transform: "translate(216.206 171.641)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 41.667,
    height: 5.12,
    transform: "translate(203.724 159.86)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 41.667,
    height: 5.12,
    transform: "translate(257.528 159.86)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 86.913,
    height: 5.12,
    transform: "translate(203.51 231.71)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 41.667,
    height: 5.12,
    transform: "translate(203.51 243.491)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 41.667,
    height: 5.12,
    transform: "translate(257.313 243.491)",
    fill: "#feab70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 55.98,
    height: 5.12,
    transform: "translate(307.167 243.491)",
    fill: "#feab70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1010",
    "data-name": "Rectangle 1010",
    width: 49.252,
    height: 5.12,
    transform: "translate(231.36 183.109)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 49.252,
    height: 5.12,
    transform: "translate(301.479 231.71)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 27.512,
    height: 5.12,
    transform: "translate(289.837 183.109)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    width: 41.23,
    height: 5.12,
    transform: "translate(321.908 183.109)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 41.667,
    height: 5.12,
    transform: "translate(316.302 159.86)",
    fill: "#feab70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    width: 41.667,
    height: 5.12,
    transform: "translate(231.36 195.138)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 18.962,
    height: 5.12,
    transform: "translate(285.171 195.138)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 48.115,
    height: 5.12,
    transform: "translate(315.033 195.138)",
    fill: "#feab70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 49.252,
    height: 5.12,
    transform: "translate(231.36 208.271)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 27.512,
    height: 5.12,
    transform: "translate(289.837 208.271)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 41.23,
    height: 5.12,
    transform: "translate(321.908 208.271)",
    fill: "#502155"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 41.667,
    height: 5.12,
    transform: "translate(231.36 220.3)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 18.962,
    height: 5.12,
    transform: "translate(285.171 220.3)",
    fill: "#bf8fa9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 48.115,
    height: 5.12,
    transform: "translate(315.033 220.3)",
    fill: "#feab70"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 269.412,
    height: 165.136,
    rx: 15.94,
    transform: "translate(119.062 133.642)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 59.467,
    height: 20.05,
    transform: "translate(257 265.281)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M326.357,334.622v3.3H324.09v-9.382h3.669a3.545,3.545,0,0,1,2.539.824,2.91,2.91,0,0,1,.874,2.226,3.116,3.116,0,0,1-.388,1.558,2.671,2.671,0,0,1-1.162,1.072,4.015,4.015,0,0,1-1.863.4Zm2.515-3.026c0-.824-.453-1.228-1.369-1.228h-1.146v2.473H327.5c.915-.033,1.369-.437,1.369-1.245Z",
    transform: "translate(-56.9 -57.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M339.69,336.213h-3.512l-.585,1.707H333.21l3.43-9.3h2.613l3.43,9.3h-2.416Zm-.585-1.723-1.121-3.446L336.8,334.49Z",
    transform: "translate(-58.501 -57.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M352.055,336.607a2.721,2.721,0,0,1-1.113.989,3.9,3.9,0,0,1-1.74.363,4.221,4.221,0,0,1-2.6-.767,2.811,2.811,0,0,1-1.113-2.143h2.416a1.261,1.261,0,0,0,.371.824,1.171,1.171,0,0,0,.824.305.956.956,0,0,0,.684-.239.9.9,0,0,0,.025-1.228,1.838,1.838,0,0,0-.577-.4c-.231-.1-.552-.223-.956-.363a11.148,11.148,0,0,1-1.451-.585,2.77,2.77,0,0,1-.965-.824,2.774,2.774,0,0,1,.017-2.91,2.721,2.721,0,0,1,1.179-.932,4.27,4.27,0,0,1,1.715-.322,3.85,3.85,0,0,1,2.473.742,2.844,2.844,0,0,1,1.039,2.036h-2.473a1.294,1.294,0,0,0-.338-.734,1,1,0,0,0-.734-.272.907.907,0,0,0-.643.214.767.767,0,0,0-.247.618.825.825,0,0,0,.214.561,1.649,1.649,0,0,0,.552.379c.223.1.536.223.956.371a10.824,10.824,0,0,1,1.468.6,2.8,2.8,0,0,1,.981.824,2.473,2.473,0,0,1,.412,1.484A2.573,2.573,0,0,1,352.055,336.607Z",
    transform: "translate(-60.651 -57.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M362.038,328.54v1.805H359.5v7.56h-2.275v-7.56H354.7V328.54Z",
    transform: "translate(-62.274 -57.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M367.027,330.346V332.3h3.166v1.715h-3.166v2.078h3.562v1.814H364.76V328.54h5.829v1.805Z",
    transform: "translate(-64.04 -57.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(0 54.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M207.747,152.887c-1.377,3.685-3.751,7.972-6.249,9.069a9.63,9.63,0,0,0-4.015,2.91l-2.284-1.327-2.729-1.583s.066-.305.2-.824.338-1.171.61-1.929a2.646,2.646,0,0,0,.33-2.473,5.631,5.631,0,0,1,.462-4.716c.874-1.27,1.723-4.4,2.251-4.312,1.278.223-.627,4.526-.082,5.326a.94.94,0,0,0,1.228.42h0c3.586-1.575,7.931-10.066,9.852-8.92C208.011,144.981,208.291,151.313,207.747,152.887Z",
    transform: "translate(-33.793 -79.868)",
    fill: "#ffb27b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    width: 21.394,
    height: 6.892,
    rx: 0.85,
    transform: "matrix(0.575, -0.818, 0.818, 0.575, 160.948, 77.754)",
    fill: "#0d458d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 21.394,
    height: 4.287,
    rx: 0.65,
    transform: "matrix(0.575, -0.818, 0.818, 0.575, 165.193, 80.746)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M115.2,132.46s22.829,39.812,31.106,47.142l30.373-22.639a11.114,11.114,0,0,1,6.34,5.771S164.58,200.312,146.418,201.9s-43.638-45.039-43.638-45.039Z",
    transform: "translate(-18.048 -77.768)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M50.2,455.3H37.013c-1.649-.907-3.141-2.968-3.6-6.043-.651-4.254-5.408-6.6-6.439-10.05s4.246-8.36,4.246-8.36l.882-1.138.923-1.187,8.789,2.045s.214,2.086.346,4.749a51.378,51.378,0,0,1,0,6.068c-.264,4.633,1.294,9.629,5.408,10.528C50.625,452.561,50.485,454.366,50.2,455.3Z",
    transform: "translate(-4.716 -129.743)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M141.376,457.714H111.242c-1.451-1.773-.915-8.3-.7-10.437.049-.429.074-.684.074-.684s10.306-8.244,11.724-1.929a2.108,2.108,0,0,0,.148.585c1.781,5.9,9.778,8.582,14.395,9.324C139.883,455.034,141,456.593,141.376,457.714Z",
    transform: "translate(-19.362 -132.159)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M131.766,256.144s-1.566,19.515-3.4,42.97c-2.473,31.865-5.507,71.009-5.771,78.429-.511,12.878-2.572,33.472-2.572,33.472s-4.922,4.889-14.692,2.828c0,0-8.723-29.4-11.212-60.514,0-.5-.082-1.022-.115-1.533-2.317-31.667-5.928-98.356-5.928-98.356Z",
    transform: "translate(-15.465 -99.007)",
    fill: "#ff973d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M131.762,256.144s-1.566,19.515-3.4,42.97L94.093,353.33c0-.5-.082-1.022-.115-1.533-2.317-31.667-5.928-98.356-5.928-98.356Z",
    transform: "translate(-15.462 -99.007)",
    fill: "#ff7e1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M114.8,256.814s-28.2,70.68-46.73,103.88-24.329,42.484-24.329,42.484-10.627-4.246-11.592-7.14c0,0,7.09-64.125,19.506-79.757,7.016-8.83,15.252-35.336,15.664-44.611s2.473-27.611,2.473-27.611Z",
    transform: "translate(-5.648 -97.36)",
    fill: "#ff973d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M117.484,128.3c-11.015,3.471-30.084-5.911-30.084-5.911s10.157-7.618,9.63-23.472l8.517,6.868,5.771,4.658a69.365,69.365,0,0,1-.66,7.568c-.165,1.27-.371,2.679-.635,4.221a26.324,26.324,0,0,1,7.461,6.068Z",
    transform: "translate(-15.348 -71.88)",
    fill: "#ffb27b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M113.375,111.875a69.371,69.371,0,0,1-.66,7.568c-6.406-1.1-13.686-11.468-13.686-11.468a20.463,20.463,0,0,1,8.558-.758Z",
    transform: "translate(-17.389 -73.309)",
    fill: "#ff9759"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M115.884,106.18s-18.2,3.026-19.91-8.335-5.21-18.624,6.34-21,14.461,1.583,15.953,5.235S120.567,105.109,115.884,106.18Z",
    transform: "translate(-16.526 -67.878)",
    fill: "#ffb27b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M130.728,234.7a1.789,1.789,0,0,1-1.154.437c-4.122-.049-16.209,2.242-26.382,1.2-8.607-.824-16.225-3.372-24.4-7.041-1.088-.486-3.586-1.822-3.529-3.034s.165-3.257.338-5.689a305.048,305.048,0,0,0,.6-39.722c-.181-3.116-.272-6.208-.28-9.258-.082-22.705,4.419-42.682,13.463-49.467.775-.552,5.516,1.773,9.893,3.916a18.08,18.08,0,0,0,11.864,1.443l3.8,3.364c4.633,4.3,9.712,10.149,11.921,19.028,1.871,7.56,2.976,21.188,3.586,35.311.272,6.4.495,12.853.552,18.962v.305c.049.61.049,1.27.049,1.88C131.223,222.012,131,234.478,130.728,234.7Z",
    transform: "translate(-13.216 -75.939)",
    fill: "#0d458d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M75.63,227.76a305.046,305.046,0,0,0,.6-39.722c-.181-3.116-.272-6.208-.28-9.259C79.719,169.637,82.8,163,82.8,163h9.5S99.267,210.579,75.63,227.76Z",
    transform: "translate(-13.281 -83.13)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M14.819,299.154l40.513,5.771a9.712,9.712,0,0,0,10.932-8.244l2.473-17.561a9.712,9.712,0,0,0-8.244-10.949L19.98,262.4a9.72,9.72,0,0,0-10.957,8.244L6.55,288.205a9.712,9.712,0,0,0,8.269,10.949Z",
    transform: "translate(-1.138 -100.563)",
    fill: "#0c3563"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M61.727,272.26h0a9.77,9.77,0,0,0-6.711-5.862h0a8.611,8.611,0,0,0-.94-.181L46,265.046l.536-3.792a3.191,3.191,0,0,0-.61-2.374,3.232,3.232,0,0,0-2.111-1.253l-2.111-.3-8.467-1.212-1.525-.214a3.215,3.215,0,0,0-3.628,2.721l-.544,3.792L13.621,260.43a9.737,9.737,0,0,0-10.99,8.244L.1,286.482a9.753,9.753,0,0,0,8.244,11l40.439,5.771a9.57,9.57,0,0,0,2.111.066h0a9.58,9.58,0,0,0,3.158-.824,9.745,9.745,0,0,0,5.722-7.519L62.3,277.215A9.588,9.588,0,0,0,61.727,272.26Zm-31.65-13.331a1.2,1.2,0,0,1,1-1.014,1.064,1.064,0,0,1,.363,0l1.8.256,6.662.956,3.636.511a1.212,1.212,0,0,1,.989,1.352l-.544,3.784-14.469-2.061Z",
    transform: "translate(-0.005 -99.434)",
    fill: "#0d458d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M51.38,242.947s-2.127,2.836-2.21,3.974c-.577,7.676,2.935,8.731-6.15,13,0,0-3.875,1.476-3.941-1.533s2.7-3.059,2.185-7.272c-.577-4.864-.519-4.905,2.671-7.42l2.111-3.487Z",
    transform: "translate(-6.865 -96.684)",
    fill: "#ffb27b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M46.413,224.722a31.066,31.066,0,0,0,7.131.4s10.149-31.37,11.493-34.239S95.2,154.092,95.2,154.092L83.175,124s-31.213,52.138-34.388,59.467c-5.235,12.1-7.057,39.244-7.057,39.244a13.191,13.191,0,0,0,4.683,2.012Z",
    transform: "translate(-7.33 -76.283)",
    fill: "#0d458d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M95.407,94.992s1.871-.313,1.566-2.886-.3-5.928,1.8-5.3,2.193,2.3,3.05,1.319.882-5.1,7.1-5.384,8.756,1.88,11.649.61,3.042-5.656,3.042-5.656a4.947,4.947,0,0,1-2.061,2.061s4.823-6.6-.767-11.13S109.5,67.06,106.265,67.258c-7.131.429-11.732.824-14.065,5.54S90.839,90.491,95.407,94.992Z",
    transform: "translate(-15.976 -66.122)",
    fill: "#0d458d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M49.862,247.63s2.053,2.135,2.177,3.026c.42,2.853,1.369,4.081.89,4.394-.989.643-2.3-1.468-2.935-3.364A8.64,8.64,0,0,1,49.862,247.63Z",
    transform: "translate(-8.726 -97.987)",
    fill: "#ffb27b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasteCode);
export default __webpack_public_path__ + "static/media/paste-code.86df59ed751a751b6ee3677c98572127.svg";
export { ForwardRef as ReactComponent };